import { TFilterRegion, TRatingType } from '../../types/filters';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EFiltersActionTypes {
  SetRatingType = 'filters/setRatingType',
  SetCurrentDate = 'filters/setCurrendDate',
  SetRegion = 'filters/setRegion',
  SetTitleForRender = 'filters/setTitleForRender',
}

export type TSetRatingType = ITypedReduxAction<EFiltersActionTypes.SetRatingType, TRatingType>;
export type TSetCurrentDate = ITypedReduxAction<EFiltersActionTypes.SetCurrentDate, string>;
export type TSetRegion = ITypedReduxAction<EFiltersActionTypes.SetRegion, TFilterRegion>;

export type TFilters = TSetRatingType | TSetCurrentDate | TSetRegion;
